import { createContext, useContext } from 'react';
import noop, { NoOp } from 'utils/noop';

type LoginContextState = {
  authCode: string;
  authReset: NoOp;
  authStateIsValid: boolean;
  authUrl: string;
};

export const LoginContext = createContext<LoginContextState>({
  authCode: '',
  authReset: noop,
  authStateIsValid: false,
  authUrl: '',
});

export const useLoginContext = () => useContext(LoginContext);
